import * as actions from "./actionsTypes";

const initialData = {
  loaderPlanAccion: false,
  planAccion: null,
  planAccionFalla: null,
  saveLoaderPlanAccion: false,
  planAccionFormError:null,
  planAccionLenght: 0
};

export default function PlanAccionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_PLAN_ACCION:
      return { ...state, loaderPlanAccion: action.payload };

    case actions.GET_PLAN_ACCION:
      return { ...state, planAccion: action.payload };

    case actions.PLAN_ACCION_FALLA:
      return { ...state, planAccionFalla: action.payload };

    case actions.SAVE_LOADER_PLAN_ACCION:
      return { ...state, saveLoaderPlanAccion: action.payload };

    case actions.FORM_PLAN_ACCION_FAIL:
      return { ...state, planAccionFormError: action.payload };
      
    default:
      return state;
  }
}
